import { type LinkType } from "@client/content/controls/Link/component";
import { type RedirectLinkProps } from "@client/content/controls/Link/Redirect/container";
import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type AnimationOptions, NO_ANIMATION_OPTIONS } from "@client/lib/jquery/animate";
import { type WithIsEditMode } from "@client/types";
import classnames from "classnames";
import * as React from "react";
import { type IconHolder } from "./container";

export const ICON_HOLDER = {
  No: "btn-icon-holder-off",
  Left: "btn-icon-left",
  Right: "btn-icon-right",
  Only: "btn-оnly-icon",
  Holder: "btn-icon-holder", // ?
  Slide: "btn-slide",
  RevealLeft: "btn-reveal btn-reveal-left",
  RevealRight: "btn-reveal"
};

export type LinkProps = RedirectLinkProps & {
  animationOptions: Partial<AnimationOptions>;
};
export type ButtonBaseProps = RootContainerProps &
  WithIsEditMode & {
    animationOptions?: AnimationOptions;
    className: string;
    icon?: string;
    iconHolder?: IconHolder;
    iconStyle?: React.CSSProperties;
    isDisabled?: boolean;
    Link: React.ComponentType<LinkProps>;
    onClick?: (e: React.MouseEvent) => void;
    style: React.CSSProperties;
    captionPropPath?: string;
    captionPropName?: string;
    caption?: string;
    tooltip?: string;
    urlType?: LinkType;

    children?: any;
  };
export default (props: ButtonBaseProps) => (
  <props.Link
    {...getEntityRef(props)}
    animationOptions={props.animationOptions || NO_ANIMATION_OPTIONS}
    className={classnames(props.className, { disabled: props.isDisabled })}
    onClick={props.isDisabled || props.isEditMode ? undefined : props.onClick}
    style={props.style}
    tooltip={props.tooltip}
  >
    {!!props.icon && props.iconHolder === "btn-icon-left" && <i className={props.icon} style={props.iconStyle} />}

    <span>
      {props.children ?? (
        <props.TextComponent
          {...getEntityRef(props)}
          tag="span"
          toolbar={"none"}
          path={props.captionPropPath}
          prop={props.captionPropName ?? "caption"}
          html={props.caption ?? ""}
          isNewLineDisabled
        />
      )}
    </span>

    {!!props.icon && props.iconHolder === "btn-icon-right" && <i className={props.icon} style={props.iconStyle} />}
  </props.Link>
);
